import { Tooltip } from "antd";
import { CopyOutlined, LinkOutlined, CheckOutlined } from "@ant-design/icons";
import { useState } from "react";

const TicketCopy = ({ formattedTicketNo }) => {
  const [copiedType, setCopiedType] = useState(null);

  const fullLink = `${process.env.REACT_APP_WEB_BASE_URL}/bugsReport/${formattedTicketNo}`;

  const copyText = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopiedType(type);
    setTimeout(() => setCopiedType(null), 1500);
  };

  return (
    <p style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "-15px" }}>
      {formattedTicketNo ? "Ticket No" : ""}: {formattedTicketNo}
      {/* Copy ticket no icon */}
      {formattedTicketNo && (
        <Tooltip title={copiedType === "ticket" ? "Copied" : "Copy ticket no"} placement="top">
          {copiedType === "ticket" ? <CheckOutlined style={{ color: "green", margin: "0 5px", fontWeight: "bold" }} /> : <CopyOutlined onClick={() => copyText(formattedTicketNo, "ticket")} style={{ margin: "0 5px", fontWeight: "bold", cursor: "pointer", color: "#1c87e5ff" }} />}
        </Tooltip>
      )}
      {/* Copy link icon */}
      {formattedTicketNo && (
        <Tooltip title={copiedType === "link" ? "Copied" : "Copy link"} placement="top">
          {copiedType === "link" ? <CheckOutlined style={{ color: "green", margin: "0 5px", fontWeight: "bold" }} /> : <LinkOutlined onClick={() => copyText(fullLink, "link")} style={{ margin: "0 5px", cursor: "pointer", color: "blue" }} />}
        </Tooltip>
      )}
    </p>
  );
};

export default TicketCopy;
